import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // fetchSingleT3: ['postSlug', 'timeStamp'],
  fetchSingleT3: ['postSlug'],
  fetchSingleT3Start: null,
  fetchSingleT3Success: ['singleT3'],
  fetchSingleT3Failure: null,

  fetchTopPicks: null,
  fetchTopPicksStart: null,
  fetchTopPicksSuccess: ['topPicks'],
  fetchTopPicksFailure: null,

  fetchRelatedArticlesForSingleT3: ['tagId', 'postId'],
  fetchRelatedArticlesForSingleT3Start: null,
  fetchRelatedArticlesForSingleT3Success: ['relatedArticles'],
  fetchRelatedArticlesForSingleT3Failure: null,

  fetchBestSoftwares: null,
  fetchBestSoftwaresStart: null,
  fetchBestSoftwaresSuccess: ['bestSoftwares'],
  fetchBestSoftwaresFailure: null
});

export { Types, Creators };
